export default class StickyHeader {
	header: HTMLElement;

	top: number;

	constructor(el: Element) {
		if(el) {
			this.top = 16;
			this.header = <HTMLElement>el;
		}
	}

	checkSticky() {
		if(window.pageYOffset > this.top) {
			this.header.setAttribute("data-status", "sticky");
		} else {
			if (this.header) {
				this.header.removeAttribute("data-status");
			}
		}
	}
}